/**
* @license Apache-2.0
*
* Copyright (c) 2018 The Stdlib Authors.
*
* Licensed under the Apache License, Version 2.0 (the "License");
* you may not use this file except in compliance with the License.
* You may obtain a copy of the License at
*
*    http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing, software
* distributed under the License is distributed on an "AS IS" BASIS,
* WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
* See the License for the specific language governing permissions and
* limitations under the License.
*/

'use strict';

// MAIN //

/**
* Initializes a cache for pooled typed array buffers.
*
* @private
* @param {NonNegativeInteger} n - base-2 logarithm of the maximum typed array size
* @returns {ArrayArray} initialized cache
*/
function pool( n ) {
	var out;
	var i;

	out = [];
	for ( i = 0; i < n+1; i++ ) {
		out.push( [] );
	}
	return out;
}


// EXPORTS //

module.exports = pool;
